export default class Video {
	constructor(element, options)
	{
		// this is an interface for Video Class. It lets us know which methods to expect, but we won't actually use it ...

		/**
		 * 
		 * We can pass options as on object
		 * 
		 * let options = 
		 * {
		 * autoplay : true,
		 * loop: true,
		 * muted: true,
		 * playsinline: true,
		 * controls: true,
		 * }
		 * 
		 */

		this.options = options;

		this.isPlaying = false;
		this.isMuted = true;
		this.duration = 0;
		this.element = element;
		this.video = element.querySelector('video');
		this.progressBar = element.querySelector('.progress-bar');
		this.progressElement = element.querySelector('.progress-bar span');
		this.animationStartTime = Date.now();

		this.buttons = 
		{
			play : this.element.querySelector('.play-button'),
			replay : this.element.querySelector('.replay-button'),
			mute: this.element.querySelector('.mute-button'),
			fullscreen: this.element.querySelector('.fullscreen-button'),
			speedOptions: this.element.querySelectorAll('.speed-button .dialog__option'),
			timerElapsed: this.element.querySelector('.timer-elapsed'),
			timerTotal: this.element.querySelector('.timer-total'),
		}

		if( this.options.click !== false)
		{
			this.video && this.video.addEventListener('click', () =>
			{
				if (this.isPlaying)
				{
					this.pause();
				} else
				{
					this.play();
				}
			})
		}

		this.buttons.play && this.buttons.play.addEventListener('click', () =>
		{
			if (this.isPlaying)
			{
				this.pause();
			} else
			{
				this.play();
			}
		})

		this.buttons.replay && this.buttons.replay.addEventListener('click', () =>
		{
			this.restart();
		})

		this.buttons.mute && this.buttons.mute.addEventListener('click', () =>
		{
			if (this.isMuted)
			{
				this.setVolume(1);
			} else
			{
				this.mute();
				this.buttons.mute.classList.add('muted');
			}
		})

		this.buttons.fullscreen && this.buttons.fullscreen.addEventListener('click', () =>
		{
			this.fullscreen();
		})

		this.buttons.speedOptions && this.buttons.speedOptions.forEach((speedOption)=>
		{
			speedOption.addEventListener('click', () => {
				console.log('speed change')
				this.changeSpeed( speedOption.dataset.value )
			})
		})

		this.buttons.timerTotal && this.options.progress !== false && this.video.addEventListener('loadedmetadata', () => 
		{
			this.initTimeDisplay()
		})

		if(this.buttons && this.progressBar) {
			if( window.matchMedia("(hover: hover)").matches ){
				this.hideControls()
			}
		}

	}
	play(){
		this.isPlaying = true;
		
		this.animationStartTime = Date.now();
		this.videoStartTime = this.video.currentTime;

		if(this.buttons.play){
			this.buttons.play.classList.add('playing');
		}
		
		if(this.options.progress !== false && this.progressBar){
			this.updateProgressDisplay();
		}
	}
	pause(){
		this.isPlaying = false;

		if(this.buttons.play){
			this.buttons.play.classList.remove('playing');
		}
		if(this.options.progress !== false && this.progressBar){
			cancelAnimationFrame(this.animationId);
		}
	}
	restart(){

	}
	mute(){
		this.isMuted = true;
	}
	fullscreen()
	{
		if (this.video.requestFullscreen) {
			this.video.requestFullscreen();
		} else if (this.video.webkitRequestFullscreen) { /* Safari */
			this.video.webkitRequestFullscreen();
		} else if (this.video.msRequestFullscreen) { /* IE11 */
			this.video.msRequestFullscreen();
		}
	}
	setVolume(amount){
		this.isMuted = false;
		this.buttons.mute.classList.remove('muted');
	}
	secondsToHms(d) 
	{
		d = Number(d);
		var h = Math.floor(d / 3600);
		var m = Math.floor((d % 3600) / 60);
		var s = Math.floor((d % 3600) % 60);

		var hDisplay = h.toString().padStart(2, '0') + ":";
		var mDisplay = m.toString().padStart(2, '0') + ":";
		var sDisplay = s.toString().padStart(2, '0');

		if( hDisplay > 0 ){
			return hDisplay + mDisplay + sDisplay;
		} else {
			return mDisplay + sDisplay;
		}
	}
	setTime(percentage)
	{
		// WE HAVE TO CALCULATE THE AMOUNT OF SECONDS FROM THE PERCENTAGE ACROSS THE PROGRESS BAR
		let seconds = Math.max( (percentage / 100) * this.video.duration, 0 )
		// console.log(percentage + '% ' + seconds + 'secs ' + this.video.playbackRate);
		console.log('Seconds of footage:'+seconds)
		this.video.currentTime = seconds;

		// CHECK IF PLAYING BEFORE RESTARTING PROGRESS BAR ANIMATION 
		if (this.isPlaying)
		{
			// THIS CANCELS THE OLD ANIMATION BEFORE ADJUSTING THE DISPLAY AND STARTING A NEW ONE
			cancelAnimationFrame(this.animationId);

			this.animationStartTime = Date.now();
			this.videoStartTime = this.video.currentTime;
			this.updateProgressDisplay();
		} else
		{
			this.animationStartTime = Date.now();
			this.videoStartTime = this.video.currentTime;
			this.updateProgressDisplay();

			// THIS CANCELS THE ANIMATION AFTER ADJUSTING DISPLAY
			cancelAnimationFrame(this.animationId);
		}
	}
	initTimeDisplay()
	{
		// SETS THE TIME TEXT DISPLAY
		this.buttons.timerElapsed.innerText = '00:00';
		this.buttons.timerTotal.innerText = this.secondsToHms(this.video.duration);

		// UNSET METADATA LISTENER
		// this.buttons.timerTotal && this.video.removeEventListener('loadedmetadata',()=>{})
	}
	updateTimeDisplay(timeElapsed)
	{
		// SETS THE TIME TEXT DISPLAY
		this.buttons.timerElapsed.innerText = this.secondsToHms(timeElapsed);
	}
	updateProgressDisplay = () =>
	{
		// THE PROGRESS BAR IS NOW AN ANIMATION
		// - This is to create a smooth transition between the timeupdate from the video
		// - The animation is started and stopped by binding to the Play and Pause methods
		// - The animation has to be adjusted based on Play back speed
		// - It then has to be restarted when it gets to the end

		// For the animation we have to establish the real world time from when we started the animation
		// And then adjust it based on the video playback rate
		// Because we need the real-world seconds elapsed now and not the video frame seconds
		const elapsedTime = (Date.now() - this.animationStartTime) / 1000;
		// console.log('real world animation time elapsed: ' + elapsedTime)

		const currentTime = elapsedTime + this.videoStartTime;

		// console.log('currentTime: '+ currentTime)

		// WORKING OUT ANIMATION SPEED BASED ON PLAYBACKRATE
		// THE CURRENT TIME ALLOWANCE NEEDS TO DOUBLE WHEN on 0.5 Speed
		let currentSpeed = 1;
		switch(this.video.playbackRate)
		{
			case 0.5:
				currentSpeed = 2;
				break;
			case 1:
				currentSpeed = 1;
				break;
			case 2:
				currentSpeed = 0.5;
				break;
		}


		if ( currentTime <= this.video.duration )
		{
			
			const progressBarWidth = 100 * (currentTime / ( this.video.duration * currentSpeed ) );
			const progressBarDistance = progressBarWidth * currentSpeed;

			// THIS SECTION IS NOT ADJUSTING THE ANIMATION TIMING PROPERLY ON DIFFERENT PLAYBACK SPEEDS
			// console.log(progressBarWidth);
			// console.log(progressBarDistance);

			this.progressElement.style.transform = `translateX(${progressBarDistance}%)`;
			this.animationId = requestAnimationFrame(this.updateProgressDisplay);

		} else {
			
			console.log('progress bar animation finished')
			// RESTART ANIMATION
			cancelAnimationFrame(this.animationId);

			this.animationStartTime = Date.now();
			this.videoStartTime = this.video.currentTime;
			this.updateProgressDisplay();
		}

	}
	updateTimeElapsed(duration, timeElapsed){

		// UPDATE PROGRESS TIMELINE
		// let percentage = Math.round((timeElapsed / duration) * 100);
		// this.updateProgressDisplay(percentage)

		// UPDATE TEXT TIMER
		this.updateTimeDisplay( timeElapsed )
	}
	getSeek(duration, currentTime)
	{
		this.progressBar.addEventListener('click', (e)=> 
		{
			e.preventDefault();
			e.stopPropagation();
			let width = this.progressBar.offsetWidth;
			let rect = e.target.getBoundingClientRect();
			let x = e.clientX - rect.left;
			let percentOnClick = (x / width) * 100;
		
			console.log('percentage of footage: ' + percentOnClick)

			this.setTime(percentOnClick)
		})
	}
	destroyControls()
	{
		if(this.buttons.play !== null){
			for (let button in this.buttons)
			{
				this.buttons[button].style.display = 'none'
			}
		}
	}
	// ALSO NEED TO CLOAK THE CONTROLS ON HOVER
	hideControls()
	{
		var mTimer;
		this.element.addEventListener("mouseenter", () => {

			this.displayControls = true;
			var timeout;
			this.element.addEventListener("mousemove", () => {
				clearTimeout(timeout);
				this.element.classList.add('video--showcontrols')
				timeout = setTimeout( () => {
					this.element.classList.remove('video--showcontrols')
				}, 1500);
			})

		})
	}
	hideProgress()
	{
		if(this.progressBar !== null){
			this.progressBar.style.display = 'none';
		}
	}
	changeSpeed(speed)
	{
		this.video.playbackRate = speed;
		// ALSO NEED TO UPDATE THE PROGRESS DISPLAY WITH DIFFERENT MATHS HERE

	}
}